import React from 'react';
import loadable from '@loadable/component';
import { ErrorBoundary } from 'components/Errors';
import Loader from 'components/Loader';

const SignUp = loadable(() => import(/* webpackChunkName: "SignUp" */ './SignUp'), {
  fallback: <Loader visible />,
});

const AsyncSignUp = () => (
  <ErrorBoundary>
    <SignUp />
  </ErrorBoundary>
);

export default AsyncSignUp;
